export default __webpack_public_path__ + "static/media/sustain-logo.f3f7954a.svg";